import React from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t-4 border-[#B1050B]" data-id="element-183">
      <div className="container mx-auto px-4" data-id="element-184">
        <div className="max-w-5xl mx-auto" data-id="element-185">
          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-186">
            <div data-id="element-187">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vgAD6BMFW6FPpPWQURJJHv/logo_black_bg.jpg" alt="Garrett Auto & Truck Service Logo" className="w-48 h-auto mb-4 rounded border-2 border-[#D4AF37]" data-id="element-188" />
              <h3 className="text-xl font-bold mb-4" data-id="element-189">
                Garrett Auto and Truck Service, Inc
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-190">
                Expert automotive and truck repair services in Farmington Hills
                since 1958.
              </p>
            </div>
            <div data-id="element-191">
              <h3 className="text-xl font-bold mb-4" data-id="element-192">Quick Links</h3>
              <ul className="space-y-2" data-id="element-193">
                <li data-id="element-194">
                  <a href="#home" className="text-gray-400 hover:text-[#B1050B] transition-colors" data-id="element-195">
                    Home
                  </a>
                </li>
                <li data-id="element-196">
                  <a href="#about" className="text-gray-400 hover:text-[#B1050B] transition-colors" data-id="element-197">
                    About
                  </a>
                </li>
                <li data-id="element-198">
                  <a href="#services" className="text-gray-400 hover:text-[#B1050B] transition-colors" data-id="element-199">
                    Services
                  </a>
                </li>
                <li data-id="element-200">
                  <a href="#dot-cdl" className="text-gray-400 hover:text-[#B1050B] transition-colors" data-id="element-201">
                    DOT & CDL
                  </a>
                </li>
                <li data-id="element-202">
                  <a href="#trailer-rv" className="text-gray-400 hover:text-[#B1050B] transition-colors" data-id="element-203">
                    Trailer & RV
                  </a>
                </li>
                <li data-id="element-204">
                  <a href="#contact" className="text-gray-400 hover:text-[#B1050B] transition-colors" data-id="element-205">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-206">
              <h3 className="text-xl font-bold mb-4" data-id="element-207">Contact Info</h3>
              <div className="space-y-3" data-id="element-208">
                <p className="flex items-center text-gray-400" data-id="element-209">
                  <PhoneIcon size={18} className="mr-2 text-[#B1050B]" data-id="element-210" />
                  <a href="tel:2484788382" className="hover:text-[#B1050B] transition-colors" data-id="element-211">
                    (248) 478-8382
                  </a>
                </p>
                <p className="flex items-start text-gray-400" data-id="element-212">
                  <MapPinIcon size={18} className="mr-2 mt-1 text-[#B1050B]" data-id="element-213" />
                  <span data-id="element-214">
                    24445 Grand River Ave
                    <br data-id="element-215" />
                    Farmington Hills, MI 48335
                  </span>
                </p>
                <p className="flex items-start text-gray-400" data-id="element-216">
                  <ClockIcon size={18} className="mr-2 mt-1 text-[#B1050B]" data-id="element-217" />
                  <span data-id="element-218">Mon-Fri: 7:00 AM - 4:00 PM</span>
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 text-center" data-id="element-219">
            <p className="text-gray-400" data-id="element-220">
              &copy; {new Date().getFullYear()} Garrett Auto and Truck Service,
              Inc. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}